import React from 'react';
import Proptypes from 'prop-types';
import Image from 'next/image';

const GiveawayBanner = ({ block }) => {
  if (!block) return '';

  const { primary } = block;

  return (
    <>
			<div className='main-container'>
				<div className='image-section' onClick={() => window.location.href = primary.product_link}>
					<Image draggable={false}  src={primary.banner.url} width={primary.banner.dimensions.width} height={primary.banner.dimensions.height} alt="banner"/>
				</div>
			</div>	

      <style jsx>
        {`
          .main-container {
						display: flex;
						justify-content: center;
						align-items: center;
						margin-bottom: 50px;
          }
					.image-section {
						width: 60%;
						cursor: pointer;
					}
        `}
      </style>
    </>
  );
};

GiveawayBanner.propTypes = {
  block: Proptypes.shape({
    primary: Proptypes.shape({
      product_link: Proptypes.string,
      banner: Proptypes.string,
    }),
    items: Proptypes.array,
  }),
};

GiveawayBanner.defaultProps = {
  block: null,
};

export default GiveawayBanner;